import { render, staticRenderFns } from "./CustomButtonTwo.vue?vue&type=template&id=bcab956a&"
import script from "./CustomButtonTwo.vue?vue&type=script&lang=js&"
export * from "./CustomButtonTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports